import React from 'react';


import { makeStyles } from 'tss-react/mui';
import { Box, Typography } from 'web-library';
import { PaginatedData } from 'web-library/models/List';
import { AnnouncementConfig, AnnouncementDetail } from 'web-library/models/Announcements';
import { useTranslation } from 'react-i18next';
import NoticeBoardHeader from './NoticeBoardHeader';
import AnnouncementCard from './AnnouncementCard';

const useStyles = makeStyles()((theme) =>
({
  container: {
    padding: theme.spacing(3),
    background: theme.color.background.bgHover01,
    borderRadius: theme.spacing(2),
    minHeight: theme.spacing(40),
  },
  content: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(2),
  },
  noAnnouncementMessage: {
    display: 'flex',
    height: theme.spacing(15),
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    color: theme.color.text.textAccent,
  },
}));

interface AnnouncementNoticeBoardProps {
  announcementDetailPage: PaginatedData<AnnouncementDetail>;
  announcementConfig: AnnouncementConfig;
}

const DesktopNoticeBoard = ({
  announcementDetailPage: { content: announcementDetails, totalElements: totalAnnouncements },
  announcementConfig,
}: AnnouncementNoticeBoardProps) => {
  const { classes } = useStyles();

  const { t } = useTranslation();

  return (
    <Box className={classes.container}>
      <NoticeBoardHeader totalAnnouncements={totalAnnouncements} />
      {totalAnnouncements ? (
        <Box className={classes.content}>
          {announcementDetails.map((announcementDetail) => (
            <AnnouncementCard
              key={announcementDetail.uuid}
              announcementDetail={announcementDetail}
              announcementConfig={announcementConfig}
              showReadMore
            />
          ))}
        </Box>
      ) : (
        <Typography className={classes.noAnnouncementMessage} variant="h3">
          {t('admin->>AnnouncementNoticeBoard.NoAnnouncementMessage')}
        </Typography>
      )}
    </Box>
  );
};

export default DesktopNoticeBoard;
